import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let pending = null;

export const assetUrl = (u) => (!u ? '' : u.startsWith('/api/') ? `${BACKEND}${u}` : u);

let fetchedAt = 0;

// Fresh fetch per page view; mounts within 3s share one request.
const load = () => {
  if (!pending || Date.now() - fetchedAt > 3000) {
    fetchedAt = Date.now();
    pending = axios.get(`${BACKEND}/api/site-assets`)
      .then((r) => { cache = Object.fromEntries((r.data.assets || []).map((a) => [a.id, a.value])); return cache; })
      .catch(() => { pending = null; return cache || {}; });
  }
  return pending;
};

const listeners = new Set();
export const invalidateSiteAssets = () => { pending = null; load().then((c) => listeners.forEach((fn) => fn(c))); };

const useAsset = (id, fallback) => {
  const [value, setValue] = useState(cache?.[id] || fallback);
  useEffect(() => {
    let alive = true;
    const apply = (c) => alive && setValue(c[id] || fallback);
    load().then(apply);
    listeners.add(apply);
    return () => { alive = false; listeners.delete(apply); };
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  return value;
};

export const useSiteImage = (id, fallback) => assetUrl(useAsset(id, fallback)) || fallback;

export const useSiteText = (id, fallback) => useAsset(id, fallback) || fallback;
